var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876_65481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6172 0C10.0012 0 4.61719 5.42133 4.61719 12.0867C4.61719 21.5573 15.4892 31.336 15.9519 31.7467C16.1347 31.9104 16.3715 32.001 16.6169 32.0012C16.8624 32.0015 17.0993 31.9113 17.2825 31.748C17.7452 31.336 28.6172 21.5573 28.6172 12.0867C28.6172 5.42133 23.2332 0 16.6172 0ZM16.6172 18.6667C12.9412 18.6667 9.95052 15.676 9.95052 12C9.95052 8.324 12.9412 5.33333 16.6172 5.33333C20.2932 5.33333 23.2839 8.324 23.2839 12C23.2839 15.676 20.2932 18.6667 16.6172 18.6667Z",
    fill: "#ED5722"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.8609,
    cy: 12.2437,
    r: 7.7554,
    fill: "#ED5722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876_65481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.617188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.8611bfdc7292c1594c4284ec0acb79e0.svg";
export { ForwardRef as ReactComponent };